<template>
  <div id="monitoringNow" class="content-view">
    <el-container>
      <el-aside width="280px">
        <div class="col-bg">
          <div class="col-bg-horn"></div>
          <div class="site-list pt30">
            <title-msg :titleMsg="titleMsg"></title-msg>
            <div class="list">
              <p @click="changeSite($event)" :class="{'active':xindex==index}" v-for="(item,index) in siteList"
                :data-index="index" :data-id="item.siteId" :key="index">
							<span class="img"></span>
								{{item.siteName}}</p>
            </div>
          </div>
        </div>
      </el-aside>
      <el-main class="col-bg ml20">
				<div class="col-bg-horn"></div>
        <div class="vidoe-btn clearfix" style="overflow:height;">
          <div class="grid-content bg-purple fr radio-btn" style="padding-top:20px;margin-bottom: 20px">
            <el-button-group>
              <!-- <el-button :type="classtype1" @click="selecttype('classtype1',1,24)">单屏</el-button> -->
              <el-button @click="selecttype('classtype2',4,12)"><i class="iconfont icon-btn"
                  :class="{ 'active': classtype2 }">&#xe61a;</i></el-button>
              <el-button @click="selecttype('classtype3',9,8)"><i class="iconfont icon-btn"
                  :class="{ 'active': classtype3 }">&#xe620;</i></el-button>
              <el-button @click="selecttype('classtype4',16,6)"><i class="iconfont icon-btn"
                  :class="{ 'active': classtype4 }">&#xe622;</i></el-button>
            </el-button-group>
          </div>
        </div>
				<div style="height: calc(100% - 80px);overflow-y: auto;overflow-x: hidden;">
        <el-row :gutter="10">
          <el-col v-for="(n,index) in fornum" :xs="24" :sm="24" :md="clonum" :lg="clonum" :xl="clonum"
            :class="videoclass" :key="index">
            <div class="player-wrapper" element-loading-text="加载中..." element-loading-background="#000">
              <div class="video-wrapper"  :id="`videoid${n}`">
                <div class="video-inner live hide-waiting"
                  style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px;">
                  <div class="alt table-c">
                    <div class="talbetop">
                      <div style="" class="video"  :data-index="index">
                        <my-video :index="index" :urlList="urlList[index]"></my-video>
                      </div>
                      <div class="operate">
                        <div class="close-video">
                          <svg class="svg-icon"
                            style="width:24px; height:24px; margin-top:-0.05rem;left:40;vertical-align: middle; fill:#52C41B">
                            <use xlink:href="#close"></use>
                          </svg>
                        </div>
                      </div>
                      <!-- <table>
                        <tr>
                          <td>无信号</td>
                        </tr>
                      </table> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
				</div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { listVideo } from "@/api/video/monitor";
import { listSite } from "@/api/configuration/site";
import myVideo from "./compontents/myVideo";
import titleMsg from "../../components/titleMsg";
export default {
  name: "monitoringNow",
  data: function() {
    return {
			titleMsg:'数据检测站点',
      player: Function,
      urlList: [],
      fullscreen: false,
      fornum: 4,
      clonum: 12,
			dialogFormVisible: false,
			videoclass:'',
      // videoclass:
      //   "padding-bottom: 46.75%; position: relative; margin: 0px auto; overflow: hidden;",
      classtype1: "",
      classtype2: "primary",
      classtype3: "",
      classtype4: "",
      items: [false, false, false, false],
      siteList: [],
      // 参数
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      xindex: 0,
      param: {
        enterprisesId: ""
      }
    };
  },
  components: {
		myVideo,
		titleMsg
  },
  created() {
    let that = this;
    window.onresize = function() {
      if (!that.checkFull()) {
        that.fullscreen = false;
        for (let n = 1; n <= that.fornum; n++) {
          // document.getElementById("videoid" + n).style =
          //   "padding-bottom: 46.25%; position: relative; margin: 0px auto;";
        }
      } else {
        for (let n = 1; n <= that.fornum; n++) {
          // document.getElementById("videoid" + n).style =
          //   "padding-bottom: 46.25%; position: relative; margin: 0px auto;";
        }
      }
    };
      this.param = { ...this.queryParams };
    // }
    this.siteList = this.$store.getters.siteList;
    this.getList(this.siteList[0].siteId);
  },
  methods: {
    // 获取站点列表
    getSiteList() {
      listSite(this.param).then(response => {
        this.siteList = response.rows;
        this.$set(this.queryParams, "siteIds", response.rows[0].siteId);
        this.getList();
      });
    },
    //选择站点
    changeSite(event) {
			this.xindex = event.target.dataset.index;

      this.$set(this.queryParams, "siteId", event.target.dataset.id);
      this.getList(event.target.dataset.id);
    },
    getList(siteId) {
      if (siteId) {
        this.$set(this.queryParams, "siteId", siteId);
        listVideo(this.queryParams).then(response => {
					this.urlList = response.rows;
        });
      } else {
        return;
      }
    },
    showselect(item1) {
      this.items = [];
      for (let i = 0; i < this.fornum; i++) {
        if (item1 == i) {
          this.items[i] = true;
        } else {
          this.items[i] = false;
        }
      }
    },
    selecttype(item, fnum, clo) {
      this.items = [];
      for (let i = 0; i < fnum; i++) {
        this.items[i] = false;
      }
      this.fornum = fnum;
      this.clonum = clo;

      if (item === "classtype1") {
        this.classtype1 = "primary";
        this.classtype2 = "";
        this.classtype3 = "";
        this.classtype4 = "";
      } else if (item === "classtype2") {
        this.classtype1 = "";
        this.classtype2 = "primary";
        this.classtype3 = "";
        this.classtype4 = "";
      } else if (item === "classtype3") {
        this.classtype1 = "";
        this.classtype2 = "";
        this.classtype3 = "primary";
        this.classtype4 = "";
      } else if (item === "classtype4") {
        this.classtype1 = "";
        this.classtype2 = "";
        this.classtype3 = "";
        this.classtype4 = "primary";
      }
    },
    checkFull() {
      //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      //火狐浏览器
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        //谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },

    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      let that = this;
      // alert(this.fullscreen)
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        // alert("ddd")
        //that.videoclass='padding-bottom: 42.25%; position: relative; margin: 0px auto; overflow: hidden;';
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
        // this.videoclass='';
        // this.tableclass='table-c'

        //this.tableclass='alt'
      }
      this.fullscreen = !this.fullscreen;
    }
  },
  watch: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.iconfont{
	color: #a4dcf5;
}
.site-list {
  // margin-left: 20px;
  // box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  // height: 100vh;
  span.title {
    font-size: 18px;
    color: #fff;
    margin-top: 30px;
    display: inline-block;
    // border-bottom: 2px solid rgba(25, 191, 189, 0.5);
    &::before {
      content: "";
      width: 6px;
      height: 24px;
      background-color: #209b9a;
      border-radius: 10px;
      display: inline-block;
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .list {
    padding: 0 0px;
    margin-top: 15px;
    height: calc(100% - 100px);
    overflow: auto;
    p {
      height: 60px;
      line-height: 60px;
      text-indent: 15px;
      margin: 10px 0;
      font-size: 16px;
      color: #a4dcf3;
      text-align: left;
      cursor: pointer;
      &:hover,
      &.active {
        background-color: #224794;
        border-radius: 2px;
				color: #fff;
				position: relative;
        &::before {
          content: "";
          width: 3px;
          height: 60px;
          background-color: #a4dcf5;
          display: inline-block;
          margin-right: 10px;
					vertical-align: middle;
					position: absolute;
					top:0;
					left: 0;
				}
				.img{
					background-image: url("../../../static/img/site-selected.png");
				}
			}
			.img{
				width: 20px;
				height: 20px;
				display: inline-block;
				background-image: url("../../../static/img/site-default.png");
				vertical-align: middle;
				margin-right: 10px;
			}
    }
  }
}
</style>
<style lang="scss">
.video-wrapper {
  position: relative;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
	min-height: 340px;
}
.alt {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000;
  color: #fff;
  text-align: center;
}
.alt table {
  width: 100%;
  height: 100%;
}
.talbetop {
  width: 100%;
  height: 100%;
  position: relative;
  .video {
    // position: relative;
    // display: grid;
    // grid-template-columns: repeat(auto-fit, 48%);
    // grid-template-rows: repeat(2,160px);
    // grid-gap: 10px 10px;
    width: 100%;
    height: 100%;
    // position: absolute;
    // left: 0;
    // top: 0;
    // right: 0;
    // bottom: 0;
    // background: red;
    z-index: 1000;
    .aliPlayer {
      width: 100%;
      height: 100%;
      margin-bottom: 10px !important;
    }
  }
}
.selectchannel {
  position: absolute;
  right: 5px;
  top: 5px;
}
.video-close {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #fff;
  font-size: 12px;
  background-color: hsla(0, 0%, 50%, 0.5);
  padding: 2px 5px;
  cursor: pointer;
  border-radius: 2px;
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.table-c table {
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
}
.table-c table td {
  border-left: 2px solid #fff;
  border-top: 2px solid #fff;
}
/*
css 注释：
只对table td设置左与上边框；
对table设置右与下边框；
为了便于截图，我们将css 注释说明换行排版
*/
.player-wrapper {
  padding-bottom: 10px;

}
</style>
